import React from 'react';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Checkbox } from 'primereact/checkbox';
import { InputNumber } from 'primereact/inputnumber';
import { getSubtypeHeader } from '../../../utils/subTypeHeader';

export default function TransportForm({ shopType, formState, setFormState }) {
  const subtype = shopType;
  const headerText = getSubtypeHeader(subtype);

  const handleCheckboxChange = (key, value) => {
    setFormState(key, value);
  };



  const pricingsubtypes = [
    { label: 'Fixed', value: 'Fixed' },
    { label: 'Hourly', value: 'Hourly' },
    { label: 'Custom', value: 'Custom' }
  ];

  const bookingMethods = [
    { label: 'Form', value: 'Form' },
    { label: 'Call', value: 'Call' },
    { label: 'Walk-in', value: 'Walk-in' }
  ];

  return (
    <div className="form-section">
      <h3 className="section-title">{headerText}</h3>

      {/* Auto Repair / Detailing */}
      {subtype === 'TA_autoRepair' && (
        <>
          <div className="field">
            <label>Repair Services</label>
            <InputText
              value={formState[`repairServices_${subtype}`] || ''}
              onChange={(e) => setFormState(`repairServices_${subtype}`, e.target.value)}
              placeholder="e.g. Engine, Transmission, AC"
            />
          </div>

          <div className="field">
            <label>Detailing Packages</label>
            <InputText
              value={formState[`detailingPackages_${subtype}`] || ''}
              onChange={(e) => setFormState(`detailingPackages_${subtype}`, e.target.value)}
              placeholder="e.g. Exterior Wash, Interior Deep Clean"
            />
          </div>

          <div className="field">
            <label>Certifications (Optional)</label>
            <InputText
              value={formState[`certifications_${subtype}`] || ''}
              onChange={(e) => setFormState(`certifications_${subtype}`, e.target.value)}
              placeholder="e.g. TESDA Certified"
            />
          </div>
        </>
      )}

      {/* Car Rentals / Taxi Services */}
      {subtype === 'TA_carRental' && (
        <>
          <div className="field">
            <label>Vehicle subtypes</label>
            <InputText
              value={formState[`vehiclesubtypes_${subtype}`] || ''}
              onChange={(e) => setFormState(`vehiclesubtypes_${subtype}`, e.target.value)}
              placeholder="e.g. Sedan, Van, SUV"
            />
          </div>

          <div className="field">
            <label>Pricing subtype</label>
            <Dropdown
              value={formState[`pricingsubtype_${subtype}`]}
              options={pricingsubtypes}
              onChange={(e) => setFormState(`pricingsubtype_${subtype}`, e.value)}
              placeholder="Select Pricing subtype"
            />
          </div>

          <div className="field">
            <label>Booking Method</label>
            <Dropdown
              value={formState[`bookingMethod_${subtype}`]}
              options={bookingMethods}
              onChange={(e) => setFormState(`bookingMethod_${subtype}`, e.value)}
              placeholder="Select Booking Method"
            />
          </div>

          <div className="field">
            <label>Driver Included?</label>
            <div className="flex align-items-center">
              <Checkbox
                inputId={`withDriver_${subtype}`}
                checked={formState[`withDriver_${subtype}`] || false}
                onChange={(e) => handleCheckboxChange(`withDriver_${subtype}`, e.checked)}
              />
              <label htmlFor={`withDriver_${subtype}`} className="ml-2">Yes</label>
            </div>
          </div>
        </>
      )}

      {/* Logistics & Delivery */}
      {subtype === 'TA_logistics' && (
        <>
          <div className="field">
            <label>Service Area</label>
            <InputText
              value={formState[`serviceArea_${subtype}`] || ''}
              onChange={(e) => setFormState(`serviceArea_${subtype}`, e.target.value)}
              placeholder="e.g. NCR, Luzon, Nationwide"
            />
          </div>

          <div className="field">
            <label>Package subtypes</label>
            <InputText
              value={formState[`packagesubtypes_${subtype}`] || ''}
              onChange={(e) => setFormState(`packagesubtypes_${subtype}`, e.target.value)}
              placeholder="e.g. Documents, Parcels, Bulk Goods"
            />
          </div>

          <div className="field">
            <label>Booking Method</label>
            <Dropdown
              value={formState[`bookingMethod_${subtype}`]}
              options={bookingMethods}
              onChange={(e) => setFormState(`bookingMethod_${subtype}`, e.value)}
              placeholder="Select Booking Method"
            />
          </div>
        </>
      )}

      {/* Bike / Scooter Rentals */}
      {subtype === 'TA_bikeRental' && (
        <>
          <div className="field">
            <label>Vehicle subtypes</label>
            <InputText
              value={formState[`vehiclesubtypes_${subtype}`] || ''}
              onChange={(e) => setFormState(`vehiclesubtypes_${subtype}`, e.target.value)}
              placeholder="e.g. Bike, E-scooter"
            />
          </div>

          <div className="field">
            <label>Rental Duration Options</label>
            <InputText
              value={formState[`rentalDurations_${subtype}`] || ''}
              onChange={(e) => setFormState(`rentalDurations_${subtype}`, e.target.value)}
              placeholder="e.g. Hourly, Daily, Weekly"
            />
          </div>

          <div className="field">
            <label>Pricing (₱)</label>
            <InputNumber
              value={formState[`rentalPricing_${subtype}`] || 0}
              onValueChange={(e) => setFormState(`rentalPricing_${subtype}`, e.value)}
              mode="currency"
              currency="PHP"
              locale="en-US"
            />
          </div>

          <div className="field">
            <div className="flex align-items-center">
              <Checkbox
                inputId={`includesHelmet_${subtype}`}
                checked={formState[`includesHelmet_${subtype}`] || false}
                onChange={(e) => handleCheckboxChange(`includesHelmet_${subtype}`, e.checked)}
              />
              <label htmlFor={`includesHelmet_${subtype}`} className="ml-2">Includes Helmet</label>
            </div>
          </div>
        </>
      )}
    </div>
  );
}